import { Box, Card, Typography } from "@mui/material";
import { Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";

const RightStatBar = ({ type }) => {
  const navigate = useNavigate();
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [tags, setTags] = useState([]);
  console.log("currentUser at right", currentUser);
  useEffect(() => {
    api
      .get("/user/trending-tags")
      .then((res) => {
        console.log("trending tags", res?.data);
        setTags(res?.data?.slice(0, 10));
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <Box
      className="right__stat__bar"
      sx={{
        // border: "1px solid gray",
        minHeight: "50vh",
        display: { xs: "none", sm: "flex" },
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {!currentUser?.isAdmin && (
        <Box
          sx={{
            width: "80%",
            padding: "30px 20px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {type == "home" ? (
            <>
              {(currentUser?.userRole == "student" ||
                currentUser?.userRole == "alumni") && (
                <Box
                  sx={{
                    color: "#fff",
                    backgroundColor: "colorOne.main",
                    padding: "6px 10px",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/ask-question")}
                >
                  ASK QUESTION
                </Box>
              )}
            </>
          ) : type == "search" ? (
            // <Box
            //   sx={{
            //     color: "#fff",
            //     backgroundColor: "colorOne.main",
            //     padding: "6px 10px",
            //     fontSize: "0.9rem",
            //     cursor: "pointer",
            //   }}
            //   onClick={() => navigate("/home")}
            // >
            //   Home
            // </Box>
            <>Search Anything</>
          ) : type == "hostels" ? (
            <>
              {currentUser?.userRole == "hostelowner" && (
                <Box
                  sx={{
                    color: "#fff",
                    backgroundColor: "colorOne.main",
                    padding: "6px 10px",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/upload-hostel-data")}
                >
                  Upload Hostel
                </Box>
              )}
            </>
          ) : type == "upload-hostel-data" ? (
            <Box
              sx={{
                color: "#fff",
                backgroundColor: "colorOne.main",
                padding: "6px 10px",
                fontSize: "0.9rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/hostels")}
            >
              See Hostels
            </Box>
          ) : type == "projects" ? (
            <>
              {" "}
              {(currentUser?.userRole == "student" ||
                currentUser?.userRole == "alumni") && (
                <Box
                  sx={{
                    color: "#fff",
                    backgroundColor: "colorOne.main",
                    padding: "6px 10px",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/post-project")}
                >
                  Post Project
                </Box>
              )}
            </>
          ) : type == "post-project" ? (
            <Box
              sx={{
                color: "#fff",
                backgroundColor: "colorOne.main",
                padding: "6px 10px",
                fontSize: "0.9rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/projects")}
            >
              See Projects
            </Box>
          ) : type == "scholarships" ? (
            <>
              {currentUser?.userRole == "sscofficer" && (
                <Box
                  sx={{
                    color: "#fff",
                    backgroundColor: "colorOne.main",
                    padding: "6px 10px",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/post-scholarship")}
                >
                  post Scholarship
                </Box>
              )}
            </>
          ) : type == "post-scholarship" ? (
            <Box
              sx={{
                color: "#fff",
                backgroundColor: "colorOne.main",
                padding: "6px 10px",
                fontSize: "0.9rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/scholarships")}
            >
              See Scholarships
            </Box>
          ) : type == "internships" ? (
            <>
              {(currentUser?.userRole == "companyrepresentative" ||
                currentUser?.userRole == "alumni") && (
                <Box
                  sx={{
                    color: "#fff",
                    backgroundColor: "colorOne.main",
                    padding: "6px 10px",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/post-internship")}
                >
                  Post Internship
                </Box>
              )}
            </>
          ) : type == "post-internship" ? (
            <Box
              sx={{
                color: "#fff",
                backgroundColor: "colorOne.main",
                padding: "6px 10px",
                fontSize: "0.9rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/internships")}
            >
              See Internsips
            </Box>
          ) : type == "my-questions" || type == "edit-question" ? (
            <Box
              sx={{
                color: "#fff",
                backgroundColor: "colorOne.main",
                padding: "6px 10px",
                fontSize: "0.9rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/ask-question")}
            >
              Ask Question
            </Box>
          ) : type == "my-hostels" || type == "edit-hostel" ? (
            <Box
              sx={{
                color: "#fff",
                backgroundColor: "colorOne.main",
                padding: "6px 10px",
                fontSize: "0.9rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/upload-hostel-data")}
            >
              Add Hostel
            </Box>
          ) : type == "fyp" ? (
            <></>
          ) : (
            <>
              <Box
                sx={{
                  color: "#fff",
                  backgroundColor: "colorOne.main",
                  padding: "6px 10px",
                  fontSize: "0.9rem",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/home")}
              >
                Newsfeed
              </Box>
            </>
          )}
        </Box>
      )}

      <Box
        sx={{
          width: "80%",
          padding: "30px 20px",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",

          marginTop: "30px",
        }}
      >
        <Typography>
          <SellOutlinedIcon sx={{ fontSize: "1.2rem" }} />
          Trending Tags
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "3px",
            marginTop: "7px",
          }}
        >
          {tags?.map((t) => (
            <Box
              sx={{
                backgroundColor: "colorFour.main",
                width: "max-content",
                padding: "3px 7px",
                fontSize: "0.8rem",
                marginTop: "4px",
              }}
            >
              {t}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default RightStatBar;
